export default {
  device: 'DESKTOP',
}
